import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import { salesDeveloperPrefix } from 'configs/routePrefix';
import { useSelector } from "react-redux";
import StatusModal from "../StatusModal"
import MessageModal from '../MessageModal';
import ClientsService from 'services/SalesDeveloper/ClientsService';

const CardItem = ({ history, item, setShouldGetData }) => {
    const AuthData = useSelector(state => state.Auth);
    const clientsService= new ClientsService()
    const isExist = (data) => AuthData.permissions[data]
    const [modalStatus, setModalStatus] = useState(false)
    const [messageModal, setMessageModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => setDropdownOpen(prevState => !prevState);

    return (
        <>
            <tr key={item.id}>
                <th className="font-size-14">{item.id}</th>
                <th className="font-size-14">{item.name}</th>
                <th className="font-size-14">{item.phone}</th>
                <th className="font-size-14">{item.open_deals}</th>
                <th className="font-size-14">{item ?.owner ?.name}</th>
                <th className="font-size-14">{item.last_visited}</th>
                <th className="font-size-14">{item.nom_searches}</th>
                <th className="font-size-14">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item.status) }}>{item.status}
                    </Badge>
                </th>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth mb-4 py-0" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => { history.push(`${salesDeveloperPrefix}/manage-clients/view-client/${item.id}`) }}>View</DropdownItem>
                            
                            {isExist('sales_developer_send_mail_for_a_client') && <DropdownItem onClick={() => setMessageModal(!messageModal)}>Send Message</DropdownItem>}
                            {isExist("manage_client_status") && <DropdownItem onClick={() => setModalStatus(true)}>Change Status</DropdownItem>}
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            {modalStatus && <StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                setShouldGetData={setShouldGetData}
            />}
            {messageModal && <MessageModal 
                modal={messageModal}
                id={item.id}
                setModal={setMessageModal}
                Service={clientsService}
            />}
        </>

    );
}


const getBackGround = (status) => {
    return status === "Wrong number" ? "#f1874c"
    : status === "Busy" ? "#f1b44c"
        : status === "Not interested" ? "#50a5f1"
            : status === "Not yet" ? "#74788d"
                : status === "Interested to buy" ? "#931b7f"
                    : status === "Unreachable" ? "#556ee6"
                        : status === "Interested to sell" ? "#54188d"
                            : status === "VIP" ? "#6498ac" 
                            :status==="Deal" ? "#34e38f" :"#95788d"
}
export default CardItem;